// Parsing centralizado dos erros de validação do backend.
// O safetycare-api padroniza erros de validação como:
//   { error_type: "record_invalid", errors: { campo: ["msg 1", "msg 2"] } }
// (ver ApplicationController rescue_from ActiveRecord::RecordInvalid).
//
// parseRecordInvalid mapeia as chaves da API (snake_case, nomes do model) para
// os nomes de campo do formulário, e separa o que não tem campo correspondente
// em `general` (ex.: e-mail imutável vindo do convite).

/**
 * @param {any} error erro do axios (ou objeto de resposta)
 * @param {Record<string,string>} fieldMap chave da API → campo do form
 * @returns {{ isValidation: boolean, fieldErrors: Record<string,string[]>, general: string[] }}
 */
export function parseRecordInvalid(error, fieldMap = {}) {
  const body =
    (error && error.response && error.response.data) ||
    (error && error.data) ||
    error ||
    {};

  const isValidation =
    body.error_type === "record_invalid" &&
    body.errors &&
    typeof body.errors === "object";

  if (!isValidation) {
    return { isValidation: false, fieldErrors: {}, general: [] };
  }

  const fieldErrors = {};
  const general = [];

  Object.keys(body.errors).forEach(apiKey => {
    const messages = normalizeMessages(body.errors[apiKey]);
    if (!messages.length) return;
    const formField = fieldMap[apiKey];
    if (formField) {
      fieldErrors[formField] = (fieldErrors[formField] || []).concat(messages);
    } else {
      general.push(...messages);
    }
  });

  return { isValidation: true, fieldErrors, general };
}

// Aceita ["msg"] ou "msg" ou {details:"msg"} → sempre array de strings.
function normalizeMessages(value) {
  if (Array.isArray(value)) return value.map(String).filter(Boolean);
  if (value == null) return [];
  if (typeof value === "object") {
    return Object.values(value)
      .flatMap(normalizeMessages)
      .filter(Boolean);
  }
  return [String(value)].filter(Boolean);
}

// --- Modo Pré-Lançamento -----------------------------------------------------
// Reconhecimento do bloqueio em UM lugar só: o interceptor do axios e o catch do
// login precisam da mesma resposta. O login é o caso novo — com o modo ligado o
// backend recusa a sessão de quem está fora do snapshot em vez de devolver
// token, e "e-mail e/ou senha incorretos" seria a mensagem errada.
//
// O discriminador é o `error_type`, nunca o status: o backend responde 401 (para
// que o app Android instalado volte sozinho para a tela de login), mas a barreira
// não é sessão expirada e não pode cair no fluxo de "faça login novamente".
export const PRE_LAUNCH_ERROR_TYPE = "pre_launch_blocked";

export function isPreLaunchBlocked(error) {
  const body = error && error.response && error.response.data;

  return !!body && body.error_type === PRE_LAUNCH_ERROR_TYPE;
}

// `errors` chega como array — formato que o decodificador de erro do app Android
// entende. O formato antigo `{ details: "msg" }` continua aceito para não depender
// da ordem de deploy entre API e webapp.
export function preLaunchBlockedMessage(error) {
  const body = (error && error.response && error.response.data) || {};

  return normalizeMessages(body.errors)[0] || null;
}
